export enum Errors {
  SEARCH_ALERTS_FETCH_ERROR_API_ERROR = 'Search alerts - Fetch error - API error',
  SEARCH_RESULTS_API_ERROR = 'Search Results - API error',
}
